// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"081e8a62","124":"eac48962","415":"3a7b7148","538":"aeed7b96","593":"2596bbab","745":"8054a5bb","897":"70c82e77","927":"d4d19478"}[chunkId] + ".chunk.css";
};